import { put, takeLatest, call } from 'redux-saga/effects';
import Settings from '@interfaces/settings';
import HeadMenu from '@interfaces/head-menu';
import CustomPage from '@interfaces/custom-page';
import { redirectToNotFound } from 'client/helpers/redirectTo';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';
import { LOCATION_CHANGE } from 'connected-react-router';

function* initApplication() {
    yield fetchSettings();
    yield fetchAppMenu();
}

function* fetchSettings() {
    try {
        const data: Settings = yield call(service.fetchSettings);

        yield put(actions.fetchSettingsSuccess(data));
    } catch (error) {
        yield put(actions.fetchSettingsError(error.message));
    }
}

function* fetchAppMenu() {
    try {
        const data: HeadMenu = yield call(service.fetchAppMenu);

        yield put(actions.fetchAppMenuSuccess(data));
    } catch (error) {
        yield put(actions.fetchAppMenuError(error.message));
    }
}

function* fetchCustomPage(action: any) {
    try {
        const data: CustomPage = yield call(service.fetchCustomPage, action.payload);

        yield put(actions.fetchCustomPageSuccess(data));
    } catch (error) {
        yield put(actions.fetchCustomPageError(error.message));
        yield put(redirectToNotFound());
    }
}

/* tslint:disable: no-unbound-method */
function* onSideNavToggle({ payload: isOpened }: any) {
    const { documentElement, body } = document;
    const { classList } = documentElement;
    const { classList: bodyClassList } = body;

    if (isOpened) {
        const bodyBiggerWindow = documentElement.scrollHeight > documentElement.clientHeight;
        const contentHasScrollbar = body.clientWidth < window.innerWidth;
        if (bodyBiggerWindow && contentHasScrollbar) {
            body.style.paddingRight = '15px';
        }

        yield call([classList, classList.add], 'disable-scroll');
        yield call([bodyClassList, bodyClassList.add], 'disable-scroll');
    } else {
        body.style.paddingRight = '0px';

        yield call([classList, classList.remove], 'disable-scroll');
        yield call([bodyClassList, bodyClassList.remove], 'disable-scroll');
    }
}

function* onLocationChange() {
    yield put(actions.toggleSideNav(false));
}

export default function* appSaga() {
    yield takeLatest(types.INIT_APPLICATION, initApplication);
    yield takeLatest(types.FETCH_SETTING, fetchSettings);
    yield takeLatest(types.FETCH_APP_MENU, fetchAppMenu);
    yield takeLatest(types.FETCH_CUSTOM_PAGE, fetchCustomPage);
    yield takeLatest(types.TOGGLE_SIDENAV, onSideNavToggle);
    yield takeLatest(LOCATION_CHANGE, onLocationChange);
}
